/** @format */

import React, { useCallback, useEffect, useState } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import AssessmentIcon from '@material-ui/icons/Assessment';
import CardHeader from '../../components/Heading/CardHeaderExt';
import Card from '../../components/Card/Card';
import CardBody from '../../components/Card/CardBody';
import InputFormRest from '../../components/Form/InputFormRest';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import SelectFromRest from '../../components/Form/SelectFromRest';
import { useServiceUseType } from '../../modules/lib/hooks/useOperatorType';
import { configDefault } from '../../core/config';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { platformResellerConstants } from '../../modules/platformreseller/actions';
import { PlatformResellerCollectionInterface } from '../../interfaces/collections/PlatformResellerCollectionInterface';
import { useDispatch } from 'react-redux';
import { SimCardServiceTypeCollection, SimCardServiceTypeItem } from '../../interfaces/collections/SimCardServiceInterface';
import I18n from '../../components/Translate/I18n';
import AddButton from '../../components/Buttons/AddButton';
import Filter from '../../interfaces/forms/Filter';
import { FeatureTypes } from '../../modules/features/FeaturesTypes';
import {TableBody, TableCell, TableHead, TableRow, Table, withStyles} from '@material-ui/core';
import TableHeaderContentCell from '../../components/Table/TableHeaderContentCell';
import DeleteButton from '../../components/Buttons/DeleteButton';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import { pricelistSchemaConstants } from '../../modules/pricelists/reducers';
import PricelistSchemaInterface from '../../interfaces/billing/PricelistSchemaInterface';
import ServicesActivationList from './ServicesActivationList';
import ServicesActivationForm from './ServicesActivationForm';
import oplAppStyle from "../../assets/themes/OPL/jss/App/OplAppStyle";

const ServicesActivation = (props: {classes:any}): React.ReactElement => {
    const [editedUssdSmsCommunication, setEditedUssdSmsCommunication] = useState<any>(null);
    const [addMode, setAddMode] = useState<boolean>(false);

    const editCallback = (el: any): void => {
        setEditedUssdSmsCommunication(el);
    };

    const addCallback = (): void => {
        setAddMode(true);
    };

    const backToList = (): void => {
        setAddMode(false);
        setEditedUssdSmsCommunication(null);
    };

    if (addMode) {
        return <ServicesActivationForm backToList={backToList} />;
    } else if (editedUssdSmsCommunication) {
        return <ServicesActivationForm editEntity={editedUssdSmsCommunication} backToList={backToList} />;
    } else {
        return <ServicesActivationList classes={props.classes} addCallback={addCallback} editCallback={editCallback} />;
    }
};

export default withStyles(oplAppStyle)(ServicesActivation);
